import { FC, ReactNode, useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { Properties } from "posthog-js";
import { usePostHogEnabled } from "./PosthogEnabled";
import { useAnonymizeUsageDataWithNullAsDefault } from "./useAnonymizeUsageDataWithNullAsDefault";

export interface PostHogIdentifierProps {
  user?: {
    id: string;
    name?: string;
    email?: string;
  };
  children: ReactNode;
}

export const PostHogIdentifier: FC<PostHogIdentifierProps> = (props) => {
  const { user } = props;
  const postHog = usePostHog();
  const postHogEnabled = usePostHogEnabled();
  const [anonymizeUsageData] = useAnonymizeUsageDataWithNullAsDefault();
  useEffect(() => {
    if (postHogEnabled) {
      if (anonymizeUsageData != null && !anonymizeUsageData) {
        if (user?.id != null) {
          // Identify sends an event, so you want may want to limit how often you call it
          const userProps: Properties = {};
          if (user.email != null) {
            userProps["email"] = user.email;
          }
          if (user.name != null) {
            userProps["name"] = user.name;
          }
          postHog.identify(user.id, userProps);
        }
      }
    }
  }, [
    postHogEnabled,
    anonymizeUsageData,
    user?.id,
    user?.email,
    user?.name,
    postHog,
  ]);

  return props.children;
};
